import MapArray from './map-array'
import debugFields from './debug-fields'

let id = 0
const nextId = () => id++

export default function MemoizeSimple(action, resolver) {
  const cache = MapArray()
  const wrapper = function memoizeSimple_wrapper() {
    const key = resolver
      ? resolver.apply(null, arguments)
      : arguments
    const index = cache.getIndex(key)

    if (index !== -1) {
      return cache.getByIndex(index)
    } else {
      const res = action.apply(null, arguments)
      cache.set(key, res)
      return res
    }
  }

  wrapper.id = nextId()
  wrapper.cache = cache

  return debugFields(wrapper, {
    _action: action
  })
}
